import React, { useEffect } from 'react';
import FlexComponent from '../FlexComponent';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import { ErrorMessage, Field } from 'formik';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import './form.css';
import { MultiSelect } from 'primereact/multiselect';

function HowMuchMoneySaved({ values, errors, touched, handleBlur, handleChange, setFieldValue }) {
    // Function to calculate total_amount_saved
    const calculateTotalSaved = () => {
        const amounts = [
            values.savings_in_the_bank,
            values.savings_in_cash,
            values.gifts_from_family_amount,
            values.investments_or_life_insurance_amount,
            values.retirement_amount,
            values.other_savings_amount
        ];

        const total = amounts.reduce((sum, amount) => {
            const num = parseFloat(amount) || 0;
            return sum + num;
        }, 0);

        return total;
    };

    // Update total_amount_saved whenever any amount field changes
    useEffect(() => {
        const total = calculateTotalSaved();
        setFieldValue('total_amount_saved', total.toFixed(2));
    }, [
        values.savings_in_the_bank,
        values.savings_in_cash,
        values.gifts_from_family_amount,
        values.investments_or_life_insurance_amount,
        values.retirement_amount,
        values.other_savings_amount,
        setFieldValue
    ]);

    return (
        <div style={{ width: '100%', padding: '0.5rem 0 0 6.8%' }} id='savingsAssets'>
            <div>
                <p style={{ fontSize: '28px', fontWeight: 'bold', padding: '0.75rem', fontFamily: "Barlow Semi Condensed" }}>
                    How much have you saved for buying a house so far?
                </p>
            </div>

            <FlexComponent flexDirection="column" gap="1rem" alignItems="start" style={{ width: '100%' }}>
                <FlexComponent
                    className="inputFlexContainer"
                    justifyContent="start"
                    gap="1rem"
                    alignItems="start"
                    style={{ width: '100%', marginTop: '1.2rem' }}
                >
                    <div className='inputContainerDiv' style={{ textAlign: 'start', width: '25%' }}>
                        <div className={`p-inputgroup flex-1 login-input-div`}>
                            <span className="p-inputgroup-addon" style={{ borderRight: "none" }}>
                                <i className='pi pi-dollar' style={{ background: "#333333", color: "white", padding: "5px", borderRadius: "30px" }}></i>
                            </span>
                            <InputText
                                type="number"
                                value={values.savings_in_the_bank || ""}
                                onChange={(e) => handleChange({
                                    target: {
                                        name: `savings_in_the_bank`,
                                        value: e.target.value
                                    }
                                })}
                                style={{ width: '100%', borderLeft: "none" }}
                                placeholder="Savings in the bank"
                                className='inputWithIcon'
                            />
                        </div>
                    </div>

                    <div className='inputContainerDiv' style={{ textAlign: 'start', width: '25%' }}>
                        <div className={`p-inputgroup flex-1 login-input-div`}>
                            <span className="p-inputgroup-addon" style={{ borderRight: "none" }}>
                                <i className='pi pi-dollar' style={{ background: "#333333", color: "white", padding: "5px", borderRadius: "30px" }}></i>
                            </span>
                            <InputText
                                type="number"
                                value={values.savings_in_cash || ""}
                                onChange={(e) => handleChange({
                                    target: {
                                        name: `savings_in_cash`,
                                        value: e.target.value
                                    }
                                })}
                                style={{ width: '100%', borderLeft: "none" }}
                                placeholder="Savings in Cash"
                                className='inputWithIcon'
                            />
                        </div>
                    </div>

                    <div className='inputContainerDiv' style={{ textAlign: 'start', width: '25%' }}>
                        <div className={`p-inputgroup flex-1 login-input-div`}>
                            <span className="p-inputgroup-addon" style={{ borderRight: "none" }}>
                                <i className='pi pi-dollar' style={{ background: "#333333", color: "white", padding: "5px", borderRadius: "30px" }}></i>
                            </span>
                            <InputText
                                type="number"
                                value={values.gifts_from_family_amount || ""}
                                onChange={(e) => handleChange({
                                    target: {
                                        name: `gifts_from_family_amount`,
                                        value: e.target.value
                                    }
                                })}
                                style={{ width: '100%', borderLeft: "none" }}
                                placeholder="Gifts From Family"
                                className='inputWithIcon'
                            />
                        </div>
                    </div>

                    <div className='inputContainerDiv' style={{ textAlign: 'start', width: '25%' }}>
                        <div className={`p-inputgroup flex-1 login-input-div`}>
                            <span className="p-inputgroup-addon" style={{ borderRight: "none" }}>
                                <i className='pi pi-dollar' style={{ background: "#333333", color: "white", padding: "5px", borderRadius: "30px" }}></i>
                            </span>
                            <InputText
                                type="number"
                                value={values.investments_or_life_insurance_amount || ""}
                                onChange={(e) => handleChange({
                                    target: {
                                        name: `investments_or_life_insurance_amount`,
                                        value: e.target.value
                                    }
                                })}
                                style={{ width: '100%', borderLeft: "none" }}
                                placeholder="Investments / Life Insurance"
                                className='inputWithIcon'
                            />
                        </div>
                    </div>
                </FlexComponent>

                <FlexComponent
                    className="inputFlexContainer"
                    justifyContent="start"
                    gap="1rem"
                    alignItems="start"
                    style={{ width: '100%' }}
                >
                    <div className='inputContainerDiv' style={{ textAlign: 'start', width: '25%' }}>
                        <div className={`p-inputgroup flex-1 login-input-div`}>
                            <span className="p-inputgroup-addon" style={{ borderRight: "none" }}>
                                <i className='pi pi-dollar' style={{ background: "#333333", color: "white", padding: "5px", borderRadius: "30px" }}></i>
                            </span>
                            <InputText
                                type="number"
                                value={values.retirement_amount || ""}
                                onChange={(e) => handleChange({
                                    target: {
                                        name: `retirement_amount`,
                                        value: e.target.value
                                    }
                                })}
                                style={{ width: '100%', borderLeft: "none" }}
                                placeholder="Retirement/401k"
                                className='inputWithIcon'
                            />
                        </div>
                    </div>

                    <div className='inputContainerDiv' style={{ textAlign: 'start', width: '25%' }}>
                        <div className={`p-inputgroup flex-1 login-input-div`}>
                            <span className="p-inputgroup-addon" style={{ borderRight: "none" }}>
                                <i className='pi pi-dollar' style={{ background: "#333333", color: "white", padding: "5px", borderRadius: "30px" }}></i>
                            </span>
                            <InputText
                                type="number"
                                value={values.other_savings_amount || ""}
                                onChange={(e) => handleChange({
                                    target: {
                                        name: `other_savings_amount`,
                                        value: e.target.value
                                    }
                                })}
                                style={{ width: '100%', borderLeft: "none" }}
                                placeholder="Other amount"
                                className='inputWithIcon'
                            />
                        </div>
                    </div>

                    <div className='inputContainerDiv' style={{ textAlign: 'start', width: '25%' }}>
                        <InputText
                            value={values.specify_other_savings_amount_source || ""}
                            onChange={(e) => handleChange({
                                target: {
                                    name: `specify_other_savings_amount_source`,
                                    value: e.target.value
                                }
                            })}
                            style={{ width: '100%' }}
                            placeholder="If other, please specify source"
                        />
                    </div>
                </FlexComponent>

                <div className='inputContainerDiv' style={{ textAlign: 'start', width: '45%' }}>
                    <FlexComponent>
                        <div style={{ width: "50%" }}>Total Amount Saved</div>
                        <div className={`p-inputgroup flex-1 login-input-div`}>
                            <span className="p-inputgroup-addon totalAmountSaved" style={{ borderRight: "none" }}>
                                <i className='pi pi-dollar' style={{ background: "white", color: "black", padding: "5px", borderRadius: "30px" }}></i>
                            </span>
                            <InputText
                                type="number"
                                value={values.total_amount_saved || ""}
                                style={{ width: '100%', borderLeft: "none" }}
                                className='inputWithIcon totalAmountSaved'
                                readOnly
                            />
                        </div>
                    </FlexComponent>
                </div>
            </FlexComponent>
        </div>
    );
}

export default HowMuchMoneySaved;